import { cn } from '@/lib/utils.ts'
import { useTranslation } from 'react-i18next'
import getEventString from '@/routes/projectStages/notifications/lib/helpers/getEventString.ts'
import { SingleIssueEvent } from '@/routes/projectStages/issue/types/issue.ts'
import { ProjectStagesUsersT } from '@/components/common/menu/lib/types/projectStagesUsers.ts'
import { useUserStore } from '@/store/user.ts'

type PropsT = {
  event: SingleIssueEvent
  projectUsers: ProjectStagesUsersT | undefined | null
  location?: 'toast' | 'notificationsList'
}

export default function NotificationEventTypeString({ event, projectUsers, location }: PropsT) {
  const { t } = useTranslation()
  const currentUserId = useUserStore(state => state.user)?.id
  const eventStringsArr = getEventString(event, projectUsers, t, currentUserId)

  if (eventStringsArr?.length === 0) return <></>
  return (
    <p className={cn(`space-x-1`, location === 'toast' ? 'text-xxs' : 'text-xs')}>
      {eventStringsArr.map((eventString, index) => {
        return (
          <span
            key={index}
            className={cn(
              eventString.stringType === 'bold' ? 'text-black' : 'text-muted-foreground',
            )}
          >
            {eventString.string}
          </span>
        )
      })}
    </p>
  )
}
